<template>
  <div class="bc4 pt10 pb10 md-6 lg-6 max5 margin-center">
    <div class="mb10">
      <h1 class="ta2">Invalid TenantId</h1>
    </div>
    <div class="flex xs-center">
      <span class="lh125 ta2">Please refer to your administrator for the correct referral tenantId</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'invalid-tenantId'
}
</script>


// WEBPACK FOOTER //
// src/components/InvalidTenantId.vue